/**
 * My Account favorite-swatch offcanvas: reuses Free Swatches detail/cart
 * factories without booting the browse/filter page.
 */
import { createSwatchCartFavorites } from '../swatch-cart-favorites';
import { createSwatchDetail } from '../swatch-detail';

const collectUniqueCards = (app) => {
  const seen = {};
  const cards = [];
  Array.prototype.slice.call(app.querySelectorAll('.swatch-card-col')).forEach((card) => {
    const id = String(card.getAttribute('data-swatch-id') || '');
    if (!id || seen[id]) {
      return;
    }
    seen[id] = true;
    cards.push(card);
  });
  return cards;
};

const hideFavoriteCards = (app, swatchId) => {
  Array.prototype.slice.call(app.querySelectorAll('.swatch-card-col')).forEach((card) => {
    if (String(card.getAttribute('data-swatch-id')) !== String(swatchId)) {
      return;
    }
    const slide = card.closest('.glide__slide');
    const col = card.closest('.col');
    if (slide) {
      slide.parentNode.removeChild(slide);
    } else if (col) {
      col.parentNode.removeChild(col);
    } else if (card.parentNode) {
      card.parentNode.removeChild(card);
    }
  });
};

const collapsedClassForIndex = (index) => {
  if (index < 4) {
    return '';
  }
  return index < 6 ? 'd-none d-lg-block d-xl-none' : 'd-none';
};

const collapseUtilities = ['d-none', 'd-lg-block', 'd-xl-none'];


const reindexFavoritesExtras = (grid, expanded) => {
  Array.prototype.slice.call(grid.querySelectorAll(':scope > .col')).forEach((col, index) => {
    const collapsed = collapsedClassForIndex(index);
    col.classList.remove(...collapseUtilities);
    col.classList.toggle('js-favorites-extra', !!collapsed);
    if (!collapsed) {
      col.removeAttribute('data-collapsed-class');
      return;
    }
    col.setAttribute('data-collapsed-class', collapsed);
    if (!expanded) {
      col.classList.add(...collapsed.split(' '));
    }
  });
};

const anyExtraCollapsesAway = (section, expanded) => {
  const extras = Array.prototype.slice.call(section.querySelectorAll('.js-favorites-extra'));
  if (!extras.length) {
    return false;
  }
  const classesFor = el => (el.getAttribute('data-collapsed-class') || 'd-none').split(' ').filter(Boolean);
  if (expanded) {
    extras.forEach(el => el.classList.add(...classesFor(el)));
  }
  const hidden = extras.some(el => window.getComputedStyle(el).display === 'none');
  if (expanded) {
    extras.forEach(el => el.classList.remove(...classesFor(el)));
  }
  return hidden;
};

const dropDeadLoadMore = () => {
  const section = document.getElementById('account-favorite-swatches');
  if (!section) {
    return;
  }
  const wrap = section.querySelector('.js-favorites-load-more-wrap');
  if (!wrap) {
    return;
  }
  const button = section.querySelector('.js-favorites-load-more');
  const expanded = !!button && button.getAttribute('aria-expanded') === 'true';
  const grid = section.querySelector('.js-favorites-grid');
  if (grid) {
    reindexFavoritesExtras(grid, expanded);
  }
  if (anyExtraCollapsesAway(section, expanded)) {
    return;
  }
  wrap.classList.add('d-none');
  if (button) {
    button.setAttribute('aria-expanded', 'false');
    button.textContent = button.getAttribute('data-collapsed-label') || 'Load More';
  }
};

const hideDetailPanel = (detailPanel) => {
  if (!detailPanel) {
    return;
  }
  if (window.bootstrap && window.bootstrap.Offcanvas) {
    const instance = window.bootstrap.Offcanvas.getInstance(detailPanel);
    if (instance) {
      instance.hide();
      return;
    }
  }
  detailPanel.classList.remove('show');
};

const initAccountSwatchDetail = () => {
  const app = document.getElementById('account-favorites-app');
  const detailPanel = document.getElementById('swatch-detail-panel');
  if (!app || !detailPanel) {
    return;
  }

  const filteredCards = collectUniqueCards(app);
  const visualizeUrl = (app.getAttribute('data-visualize-url') || '').trim() || '#';

  const state = {
    filters: {
      color: [],
      solution: [],
      product: [],
      collection: [],
    },
    detailVariantCards: [],
    detailVariantIndex: -1,
    detailPrevNextCards: [],
    detailPrevNextIndex: -1,
  };

  const ctx = {
    app,
    state,
    filteredCards,
    detailPanel,
    visualizeUrl,
    hasActiveFilters: () => true,
    getMatchingFilteredCards: () => collectUniqueCards(app),
  };

  Object.assign(ctx, createSwatchCartFavorites(ctx));
  Object.assign(ctx, createSwatchDetail(ctx));

  ctx.bindDetailEvents();
  ctx.initCartState();

  app.addEventListener('click', (event) => {
    const viewDetail = event.target.closest('.swatch-view-detail');
    if (viewDetail && app.contains(viewDetail)) {
      const card = viewDetail.closest('.swatch-card-col');
      if (card) {
        ctx.openDetailForCard(card);
      }
      return;
    }

    const cartBtn = event.target.closest('.swatch-cart-btn');
    if (cartBtn && app.contains(cartBtn)) {
      ctx.onCartClick(cartBtn);
    }
  });

  const refreshFilteredCards = () => {
    filteredCards.length = 0;
    collectUniqueCards(app).forEach((card) => {
      filteredCards.push(card);
    });
  };

  const swatchList = document.getElementById('account-favorite-swatches');
  if (swatchList && typeof window.MutationObserver === 'function') {
    const observer = new window.MutationObserver(() => {
      ctx.initCartState();
      refreshFilteredCards();
    });
    observer.observe(swatchList, { childList: true });
  }

  ctx.onFavoriteFormPosted = ({
    form, swatchId, isAdd, actionSucceeded,
  }) => {
    if (isAdd || !actionSucceeded) {
      return;
    }

    window.dispatchEvent(new window.CustomEvent('account:swatch-removed', {
      detail: {
        swatchId,
        productLineCode: form.getAttribute('data-product-line-code'),
        colorNumber: form.getAttribute('data-color-number'),
        colorName: form.getAttribute('data-color-name'),
      },
    }));

    window.setTimeout(() => {
      hideFavoriteCards(app, swatchId);
      dropDeadLoadMore();
      refreshFilteredCards();
      if (filteredCards.length === 0) {
        hideDetailPanel(detailPanel);
        return;
      }
      ctx.openDetailForCard(filteredCards[0]);
    }, 300);
  };
};

export default initAccountSwatchDetail;
export { initAccountSwatchDetail };
